export const isIcon = (icon) => Boolean(icon?.src || icon?.icon);
//# sourceMappingURL=isIcon.js.map